<template>
  <div id="home">
    <ModalNotification v-if="showRequestsModal && checkAuthHasShowModalChangePrice">
      <template v-slot:content>
        <div class="modal-content flex items-center"> 
             <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.2197 0.219672L16.5 3.93939V1.74994C16.5 1.55103 16.421 1.36026 16.2803 1.21961C16.1397 1.07896 15.9489 0.999942 15.75 0.999942C15.5511 0.999942 15.3603 1.07896 15.2197 1.21961C15.079 1.36026 15 1.55103 15 1.74994V5.74994C15.0008 5.94862 15.08 6.13895 15.2205 6.27943C15.361 6.41992 15.5513 6.49918 15.75 6.49994H19.75C19.9489 6.49994 20.1397 6.42092 20.2803 6.28027C20.421 6.13962 20.5 5.94885 20.5 5.74994C20.5 5.55103 20.421 5.36026 20.2803 5.21961C20.1397 5.07896 19.9489 4.99994 19.75 4.99994H17.5606L21.2803 1.28021C21.4201 1.1394 21.4983 0.948925 21.498 0.750508C21.4976 0.55209 21.4186 0.361902 21.2783 0.2216C21.138 0.081297 20.9479 0.00231572 20.7494 0.00195437C20.551 0.00159302 20.3605 0.0798811 20.2197 0.219672Z" fill="black"/>
              <path d="M10.75 7.86377C11.0331 7.86406 11.3047 7.97664 11.5049 8.17683C11.7052 8.37702 11.8179 8.64847 11.8183 8.93164C11.8183 9.13055 11.8974 9.32132 12.038 9.46197C12.1787 9.60262 12.3694 9.68164 12.5683 9.68164C12.7672 9.68164 12.958 9.60262 13.0987 9.46197C13.2393 9.32132 13.3183 9.13055 13.3183 8.93164C13.3164 8.38349 13.1387 7.85042 12.8114 7.4107C12.4841 6.97097 12.0245 6.64776 11.5 6.48853V5.75C11.5 5.55109 11.421 5.36032 11.2803 5.21967C11.1397 5.07902 10.9489 5 10.75 5C10.5511 5 10.3603 5.07902 10.2196 5.21967C10.079 5.36032 9.99998 5.55109 9.99998 5.75V6.48853C9.41158 6.66675 8.90695 7.05071 8.57827 7.57027C8.24959 8.08982 8.1188 8.71028 8.20979 9.3183C8.30078 9.92632 8.60749 10.4813 9.07387 10.8819C9.54026 11.2824 10.1352 11.5018 10.75 11.5C10.9612 11.5 11.1677 11.5627 11.3433 11.6801C11.5189 11.7975 11.6558 11.9643 11.7366 12.1595C11.8174 12.3546 11.8385 12.5694 11.7973 12.7766C11.7561 12.9837 11.6544 13.174 11.505 13.3234C11.3556 13.4728 11.1653 13.5745 10.9582 13.6157C10.751 13.6569 10.5363 13.6358 10.3411 13.555C10.1459 13.4742 9.97911 13.3373 9.86173 13.1617C9.74434 12.9861 9.68166 12.7796 9.68161 12.5684C9.68161 12.3694 9.6026 12.1787 9.46195 12.038C9.32129 11.8974 9.13053 11.8184 8.93161 11.8184C8.7327 11.8184 8.54194 11.8974 8.40129 12.038C8.26063 12.1787 8.18161 12.3694 8.18161 12.5684C8.18359 13.1165 8.36127 13.6496 8.68854 14.0893C9.01582 14.529 9.47546 14.8522 9.99998 15.0115V15.75C9.99998 15.9489 10.079 16.1397 10.2196 16.2803C10.3603 16.421 10.5511 16.5 10.75 16.5C10.9489 16.5 11.1397 16.421 11.2803 16.2803C11.421 16.1397 11.5 15.9489 11.5 15.75V15.0115C12.0884 14.8332 12.593 14.4493 12.9217 13.9297C13.2504 13.4102 13.3812 12.7897 13.2902 12.1817C13.1992 11.5737 12.8925 11.0187 12.4261 10.6181C11.9597 10.2176 11.3648 9.99816 10.75 10C10.6094 10.0004 10.4702 9.97312 10.3402 9.91963C10.2103 9.86615 10.0921 9.78754 9.99259 9.68831C9.89306 9.58909 9.81409 9.47119 9.76021 9.34139C9.70632 9.21159 9.67859 9.07243 9.67859 8.93188C9.67859 8.79134 9.70632 8.65218 9.76021 8.52238C9.81409 8.39257 9.89306 8.27468 9.99259 8.17546C10.0921 8.07623 10.2103 7.99762 10.3402 7.94414C10.4702 7.89065 10.6094 7.86334 10.75 7.86377Z" fill="black"/>
              <path d="M20.75 10C20.5511 10.0001 20.3604 10.0791 20.2197 10.2197C20.0791 10.3604 20.0001 10.5511 20 10.75C20 12.5795 19.4575 14.3679 18.4411 15.889C17.4247 17.4102 15.98 18.5958 14.2898 19.2959C12.5996 19.996 10.7397 20.1792 8.94542 19.8223C7.15109 19.4654 5.5029 18.5844 4.20927 17.2907C2.91563 15.9971 2.03465 14.3489 1.67774 12.5546C1.32083 10.7603 1.50401 8.90039 2.20412 7.21018C2.90423 5.51996 4.08983 4.07531 5.61098 3.05891C7.13213 2.0425 8.92053 1.5 10.75 1.5C10.9489 1.5 11.1397 1.42098 11.2803 1.28033C11.421 1.13968 11.5 0.948912 11.5 0.75C11.5 0.551088 11.421 0.360322 11.2803 0.21967C11.1397 0.0790177 10.9489 0 10.75 0C8.62386 0 6.54545 0.630477 4.77762 1.8117C3.0098 2.99293 1.63194 4.67185 0.8183 6.63615C0.0046578 8.60046 -0.208228 10.7619 0.206563 12.8472C0.621354 14.9325 1.64519 16.848 3.14861 18.3514C4.65202 19.8548 6.56749 20.8787 8.65278 21.2934C10.7381 21.7082 12.8995 21.4953 14.8639 20.6817C16.8282 19.8681 18.5071 18.4902 19.6883 16.7224C20.8695 14.9546 21.5 12.8761 21.5 10.75C21.5 10.5511 21.4209 10.3604 21.2803 10.2197C21.1396 10.0791 20.9489 10.0001 20.75 10Z" fill="black"/>
            </svg>
            <span class="mx-2">
              طلب تغير سعر الطرد رقم {{ orderRequestsData.order.code }}
            </span>
      </div>
        <div class="w-full px-5" style="border: 0.5px solid #9E9E9E;border-radius: 3px; line-height: 3;">
          <p>الاسم : <span class="font-bold">{{ orderRequestsData.order.receiver }}</span></p>
          <p>محتوي الطرد : <span class="font-bold">{{ orderRequestsData.order.order_summary }}</span></p>
          <p>المحافظه : <span class="font-bold">{{ orderRequestsData.order.government_name }}</span></p>
          <p>المنطقه : <span class="font-bold">{{ orderRequestsData.order.area_name }}</span></p>
          <p>السعر القديم : <span class="font-bold">{{ orderRequestsData.order_amount }}</span></p>
          <p class="text-danger font-extrabold">السعر الجديد : <span class="font-extrabold">{{ orderRequestsData.new_amount
              }}</span></p>
          <p v-if="orderRequestsData.captain_notes">ملاحظات المندوب : <span class="font-bold">{{ orderRequestsData.captain_notes }}</span></p>        
        </div>
        <div class="w-full mt-8 mb-3" v-if="orderRequestsData.partial_return">
          <h3 class="pr-5" style="font-size: medium">{{ $t("has_partial_returned") }}</h3>
        </div>
      </template>
      <template v-slot:first-btn>
        <button 
          class="third-btn px-12 mt-5 text-white w-1/2 rounded-full" 
          style="background-color: #31006F;"
          :disabled="spin"
          @click="changeStatusOrderChangeRequestsPrice(true)">
            <span v-if="!spin">اوافق</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i> جاري المعالجة...
            </span>        
        </button>
      </template>
      <template v-slot:third-btn>
        <button 
          class="third-btn mt-5 px-10 w-1/2 rounded-full" 
          :disabled="spin"
          @click="changeStatusOrderChangeRequestsPrice(false)">
            <span v-if="!spin">لا اوافق</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i> جاري المعالجة...
            </span>        
        </button>
      </template>
    </ModalNotification>
    <Modal v-if="showModal" @closeModal="closePopup()">
      <template v-slot:icon>
        <img src="@/assets/images/elements/drone.svg" alt="Something wrong" />
      </template>
      <template v-slot:content>
        <p class="modal-content">تم تعديل اسعار التوصيل الى الاسعار الثابتة</p>
      </template>
      <template v-slot:second-btn>
        <button
          class="first-btn"
          @click.stop="(showNumbersModal = true), (showModal = false)"
        >
          اتصل بنا
        </button>
      </template>
    </Modal>
    <Modal v-if="showNumbersModal" @closeModal="closePopup()">
      <template v-slot:content>
        <h5 class="font-bold w-full text-center">ارقام الاستعلام</h5>
        <p class="modal-content modal-phone my-4">
          <feather-icon
            icon="PhoneIcon"
            svgClasses="text-primary h-5 w-5"
            class="mr-2"
          />{{ phone1 }}
        </p>
        <p class="modal-content modal-phone">
          <feather-icon
            icon="PhoneIcon"
            svgClasses="text-primary h-5 w-5"
            class="mr-2"
          />{{ phone2 }}
        </p>
      </template>

      >
    </Modal>
    <ModalAddVue v-if="activeSurveysModal" :title="surveyData.survey_question">
      <template #body>
        <div class="modal-input">
          <surveyInput
            v-if="!loadingUpdateClientData"
            :typeInput="surveyData.survey_type"
            v-model="updateClientData"
          />
        </div>
      </template>
      <template #footer>
        <button
          v-if="!loadingUpdateClientData"
          @click="submitData()"
          class="first-btn"
          :class="[{ 'active-btn': isFormValid }]"
          :disabled="!isFormValid"
        >
          تأكيد
        </button>
        <button class="first-btn loading-form flex justify-center" v-else>
          <spinnerColor />
        </button>
      </template>
    </ModalAddVue>
    <div class="p-6 loading-table" v-show="loadHome">
      <spinner-color />
    </div>
    <div id="dashboard-analytics" v-show="!loadHome">
      <div class="dashboard-top" style="margin-bottom: 1.5rem !important">
        <!-- CARD: features -->
        <TurboFeatures />
        <!-- CARD: PROFILE -->
        <div class="my-profile">
          <div class="profile-card">
            <img
              src="@/assets/images/elements/user2.svg"
              loading="lazy"
              class="mr-4"
              alt="User"
              width="39.75"
            />
            <div class="info-card flex justify-between">
              <div>
                <h4 style="line-height: 1.3125rem">
                  {{ hasAccess ? client.name : user.first_name }}
                </h4>
                <span class="content-card">
                  <input
                    type="hidden"
                    ref="copyText"
                    :value="hasAccess ? client.email : user.email"
                  />
                  {{ hasAccess ? client.email : user.email }}
                  <span @click="copyText('copyText')" style="cursor: pointer">
                    <svg
                      style="transform: translate(-5px, 2px)"
                      id="Icon_ionic-ios-copy"
                      data-name="Icon ionic-ios-copy"
                      xmlns="http://www.w3.org/2000/svg"
                      width="9.521"
                      height="11.901"
                      viewBox="0 0 9.521 11.901"
                    >
                      <path
                        id="Path_1006"
                        data-name="Path 1006"
                        d="M23.881,3.584h2.231a.149.149,0,0,0,.149-.149h0a.692.692,0,0,0-.248-.528L24.1,1.316a.927.927,0,0,0-.511-.183h0a.183.183,0,0,0-.183.183v1.8A.475.475,0,0,0,23.881,3.584Z"
                        transform="translate(-16.74 -1.13)"
                        fill="#6e6b7b"
                      />
                      <path
                        id="Path_1007"
                        data-name="Path 1007"
                        d="M14.166,3.109V1.125H10.918a.8.8,0,0,0-.793.793v8.331a.8.8,0,0,0,.793.793h5.951a.8.8,0,0,0,.793-.793V4.224h-2.38A1.117,1.117,0,0,1,14.166,3.109Z"
                        transform="translate(-8.141 -1.125)"
                        fill="#6e6b7b"
                      />
                      <path
                        id="Path_1008"
                        data-name="Path 1008"
                        d="M5.789,13.857V5.625h-.5a.8.8,0,0,0-.793.793v8.728a.8.8,0,0,0,.793.793h6.347a.8.8,0,0,0,.793-.793v-.5H6.583A.8.8,0,0,1,5.789,13.857Z"
                        transform="translate(-4.5 -4.038)"
                        fill="#6e6b7b"
                      />
                    </svg>
                  </span>
                </span>
                <span class="content-card"
                  >{{ $t("typeProducts") }} : {{ client.products_type }}</span
                >
                <span
                  class="content-card flex items-center"
                  style="margin-top: 0.1875rem"
                  >{{ $t("yourCode") }} :
                  <span class="code">{{ client.code }}</span>
                </span>
              </div>
              <div class="flex items-end" style="flex-direction: column">
                <div
                  data-tour-step="7"
                  class="mb-4 flex items-center cursor-pointer"
                  style="min-width: 95px; border-radius: 4px"
                  @click="$router.push('/setting-main-info').catch(() => {})"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.07"
                    height="12.073"
                    viewBox="0 0 12.07 12.073"
                  >
                    <path
                      id="Icon_ionic-ios-settings"
                      data-name="Icon ionic-ios-settings"
                      d="M15.574,10.535a1.553,1.553,0,0,1,1-1.449,6.156,6.156,0,0,0-.745-1.795,1.574,1.574,0,0,1-.632.135,1.55,1.55,0,0,1-1.418-2.181A6.138,6.138,0,0,0,11.984,4.5a1.552,1.552,0,0,1-2.9,0,6.156,6.156,0,0,0-1.795.745A1.55,1.55,0,0,1,5.874,7.426a1.523,1.523,0,0,1-.632-.135,6.293,6.293,0,0,0-.742,1.8,1.553,1.553,0,0,1,0,2.9,6.156,6.156,0,0,0,.745,1.795,1.55,1.55,0,0,1,2.046,2.046,6.192,6.192,0,0,0,1.795.745,1.549,1.549,0,0,1,2.892,0,6.156,6.156,0,0,0,1.795-.745,1.552,1.552,0,0,1,2.046-2.046,6.192,6.192,0,0,0,.745-1.795A1.561,1.561,0,0,1,15.574,10.535Zm-5.01,2.511a2.515,2.515,0,1,1,2.515-2.515A2.514,2.514,0,0,1,10.563,13.046Z"
                      transform="translate(-4.5 -4.5)"
                      fill="#6e6b7b"
                    />
                  </svg>
                  <span
                    style="
                      display: inline-block;
                      margin-right: 0.5rem;
                      font-size: 0.75rem;
                      color: #6e6b7b;
                      text-decoration: underline;
                    "
                    >{{ $t("accountSettings") }}</span
                  >
                </div>

                <div
                  class="mb-4 flex items-center cursor-pointer"
                  style="min-width: 95px"
                  @click="$router.push('/termsAndConditions').catch(() => {})"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.105"
                    height="12.105"
                    viewBox="0 0 12.105 12.105"
                  >
                    <path
                      id="Icon_awesome-question-circle"
                      data-name="Icon awesome-question-circle"
                      d="M12.667,6.615A6.052,6.052,0,1,1,6.615.563,6.052,6.052,0,0,1,12.667,6.615ZM6.777,2.564A3.161,3.161,0,0,0,3.933,4.12a.293.293,0,0,0,.066.4l.847.642a.293.293,0,0,0,.407-.052c.436-.553.735-.874,1.4-.874.5,0,1.115.321,1.115.8,0,.365-.3.553-.794.829-.574.322-1.334.722-1.334,1.724v.1a.293.293,0,0,0,.293.293H7.3a.293.293,0,0,0,.293-.293V7.656c0-.695,2.03-.724,2.03-2.6A2.784,2.784,0,0,0,6.777,2.564ZM6.615,8.616A1.123,1.123,0,1,0,7.738,9.739,1.124,1.124,0,0,0,6.615,8.616Z"
                      transform="translate(-0.563 -0.563)"
                      fill="#6e6b7b"
                    />
                  </svg>
                  <span
                    style="
                      display: inline-block;
                      margin-right: 0.5rem;
                      font-size: 0.75rem;
                      color: #6e6b7b;
                      text-decoration: underline;
                    "
                    >{{ $t("termsCondition") }}</span
                  >
                </div>

                <span class="supp" v-if="hasAccess"
                  >{{ $t("nextSupply") }} : {{ next_supply }}
                  {{ $t("pounds") }}</span
                >
              </div>
            </div>
          </div>
          <div class="cash-card flex justify-between">
            <div class="flex cash-card1" style="flex-direction: column">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.17"
                height="32.17"
                viewBox="0 0 32.17 32.17"
              >
                <path
                  v-if="hasAccess"
                  id="Icon_material-monetization-on"
                  data-name="Icon material-monetization-on"
                  d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                  transform="translate(-3 -3)"
                  fill="#31006F"
                />
                <path
                  v-else
                  id="Icon_material-monetization-on"
                  data-name="Icon material-monetization-on"
                  d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                  transform="translate(-3 -3)"
                  fill="#00000075"
                />
              </svg>
              <span class="cash1" v-if="hasAccess"
                >{{ total_balance }} {{ $t("pounds") }}</span
              >
              <span class="cash1" style="color: #212121" v-else
                >ليس لديك صلاحية</span
              >
              <span>{{ $t("totalAccount") }}</span>
            </div>
            <div class="flex cash-card2" style="flex-direction: column">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32.17"
                height="32.17"
                viewBox="0 0 32.17 32.17"
              >
                <path
                  v-if="hasAccess"
                  id="Icon_material-monetization-on"
                  data-name="Icon material-monetization-on"
                  d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                  transform="translate(-3 -3)"
                  fill="#28c76f"
                />
                <path
                  v-else
                  id="Icon_material-monetization-on"
                  data-name="Icon material-monetization-on"
                  d="M19.085,3A16.085,16.085,0,1,0,35.17,19.085,16.091,16.091,0,0,0,19.085,3Zm2.268,25.881v3.072H17.058v-3.1c-2.751-.579-5.083-2.348-5.26-5.469h3.153c.161,1.689,1.319,3.008,4.263,3.008,3.153,0,3.86-1.576,3.86-2.558,0-1.335-.708-2.59-4.295-3.442-3.989-.965-6.724-2.606-6.724-5.9,0-2.767,2.236-4.568,5-5.163v-3.1h4.295V9.354a5.686,5.686,0,0,1,4.584,5.453H22.785c-.08-1.785-1.029-3.008-3.571-3.008-2.413,0-3.86,1.094-3.86,2.638,0,1.351,1.046,2.236,4.295,3.072s6.724,2.236,6.724,6.289C26.355,26.741,24.152,28.35,21.353,28.881Z"
                  transform="translate(-3 -3)"
                  fill="#00000075"
                />
              </svg>
              <span class="cash2" v-if="hasAccess"
                >{{ total_supplied_balance }} {{ $t("pounds") }}</span
              >
              <span class="cash2" style="color: #212121" v-else
                >ليس لديك صلاحية</span
              >
              <span>{{ $t("retractableBalance") }}</span>
            </div>
          </div>
        </div>
        <!-- CARD: ORDER RECIEVED -->
          <div class="given-order">
            <div
              style="padding: 1.125rem; border-radius: 1rem; height: 100%"
              class="bg-white"
            >
              <div
                class="flex justify-between"
                style="position: relative; z-index: 2"
              >
                <div>
                  <span style="font-size: 0.875rem"
                    >{{ $t("numberOfOrder") }}
                    <span
                      style="
                        display: inline-block;
                        transform: translate(-0.125rem, 0.1875rem);
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.004"
                        height="12.004"
                        viewBox="0 0 12.004 12.004"
                      >
                        <path
                          id="Icon_awesome-check-circle"
                          data-name="Icon awesome-check-circle"
                          d="M12.567,6.565a6,6,0,1,1-6-6A6,6,0,0,1,12.567,6.565ZM5.87,9.743,10.324,5.29a.387.387,0,0,0,0-.548l-.548-.548a.387.387,0,0,0-.548,0L5.6,7.826,3.9,6.13a.387.387,0,0,0-.548,0l-.548.548a.387.387,0,0,0,0,.548L5.323,9.743a.387.387,0,0,0,.548,0Z"
                          transform="translate(-0.563 -0.563)"
                          fill="#28c76f"
                        />
                      </svg>
                    </span>
                  </span>
                  <span
                    style="
                      display: block;
                      font-size: 1.5rem;
                      color: #31006f;
                      line-height: 2.9375rem;
                      font-weight: 600;
                    "
                    >{{ this.chart.total_given }} {{ $t("order") }}</span
                  >
                </div>
              </div>
              <div style="position: relative; top: -75px; z-index: 0">
                <Pie
                  :height="180"
                  :width="270"
                  :chart-data="chartData"
                  :chart-options="chartOptions"
                />
              </div>
            </div>
          </div>
      </div>

      <vs-divider class="mb-5 mt-0" />

      <div class="second-section">
        <div class="last-orders">
          <div class="header-last-orders">
            <h3>
              <feather-icon
                icon="PackageIcon"
                svgClasses="h-6 w-6"
                class="mr-2"
              ></feather-icon>
              أخر الطلبات المحفوظة
            </h3>
            <button @click="$router.push(`/SavedOrder`).catch(() => {})">
              <feather-icon
                icon="PackageIcon"
                svgClasses="h-6 w-6"
                class="mr-2"
              ></feather-icon>
              الطلبات المحفوظة
            </button>
          </div>
          <data-table-order
            :data="this.$store.state.dataList.orders"
            :header="header"
            :body="body"
            :pageName="pageName"
            :titlePage="titlePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import globalMixin from "@/mixins/mixins.js";
import orderStatusMixin from "@/mixins/orderStatus.js";
import DataTableOrder from "@/views/components/table-components/DataTableOrder.vue";
import helper from "@/mixins/helper.js";
import { Pie } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  ArcElement,
  LinearScale
);
import aclAccess from "@/mixins/hasAccess";
import gTag from "@/mixins/gtag.js";
import Modal from "@/layouts/components/Modal.vue";
import ModalAddVue from "@/layouts/components/ModalAdd.vue";
import TurboFeatures from "./components/TurboFeatures.vue";
import surveyInput from "./components/surveyInput.vue";
import ModalNotification from "@/layouts/components/ModalNotification.vue";
import Axios from 'axios';


export default {
  mixins: [globalMixin, orderStatusMixin, helper, aclAccess, gTag],
  data() {
    return {
      partial_return: false,
      spin:false,
      orderStatus: "",
      orderCode: "",
      isSearch: false,
      haveOrder: false,
      addNewDataSidebar: false,
      chartData: {},
      sumChart: 0,
      chartOptions: {
        plugins: {
          title: {
            display: false,
          },
          tooltips: {},
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "right",
            textDirection: "rtl",
            rtl: true,
            usePointStyle: true,
            labels: {
              usePointStyle: true,
              boxWidth: 10,
              boxHeight: 10,
              font: {
                family: "Cairo",
              },
            },
          },
          responsive: true,
        },
      },
      header: [
        { header: "dateOfRegistration", key: "created_at" },
        { header: "code", key: "code" },
        { header: "sender", key: "second_client" },
        { header: "receiver", key: "receiver" },
        { header: "government", key: "gov_name" },
        { header: "area", key: "area" },
        { header: "collectedAmount", key: "amount" },
        { header: "actions", key: "actions" },
      ],
      pageName: "last/order",
      titlePage: "اخر الطلبات المحفوظة",
      body: [
        "created_at",
        "code",
        "second_client",
        "receiver",
        "gov_name",
        "area",
        "amount",
      ],
      type: 2,
      loadHome: true,
      successSearch: null,
      errorSearchMessage: "",
      loadingSearch: false,
      image: process.env.VUE_APP_CONFIGS_HOME_PAGE_IMAGE,
      logoWhite: process.env.VUE_APP_CONFIGS_MAIN_LOGO_WHITE,
      showModal: false,
      showNumbersModal: false,
      showRequestsModal: false,
      updateClientData: "",
      loadingUpdateClientData: false,
      activeSurveysModal: false,
    };
  },
  watch: {},
  components: {
    SpinnerColor,
    DataTableOrder,
    Pie,
    Modal,
    TurboFeatures,
    ModalAddVue,
    surveyInput,
    ModalNotification,
  },
  computed: {
    ...mapGetters("dataList", [
      "detail_of_order",
      "chart",
      "success_api",
      "err_msg",
    ]),
    ...mapGetters("userData", [
      "client",
      "total_supplied_balance",
      "next_supply",
      "total_balance",
      "user",
      "sub_user",
      "is_main_client",
    ]),
    ...mapGetters("samsaApi", [
      "detail_of_samsa_order",
      "error_samsa_order",
      "success_api_samsa_order",
    ]),
    ...mapState("auth", ["phone1", "phone2"]),
    ...mapState("survey", [
      "surveyData",
      "err_survey",
      "success_submit_survey",
      "available_surveys",
    ]),
    isFormValid() {
      if (!this.errors.any()) {
        return true;
      }
      return false;
    },
    checkAuthHasShowModalChangePrice() {
      let authUser = this.user;
      let subUsers = this.sub_user;
      let authIsMainClientOrSubUser = this.is_main_client;
      if(authIsMainClientOrSubUser) {
        return true;
      }
      let authSubUser = subUsers.find((subUser) => subUser.id == authUser.id);
      if (authSubUser && authSubUser.permissions_flags) {
          return authSubUser.permissions_flags.show_modal_change_request_price;
      }
      return false;
    },
  },
  methods: {
    ...mapActions("dataList", [
      "orderDetails",
      "fetchChart",
      "fetchDataListItems",
    ]),
    ...mapActions("samsaApi", ["internationalSearch"]),
    ...mapActions("auth", ["confirmRestored"]),
    ...mapActions("survey", ["getSurvey", "submitSurvey"]),
    ...mapActions("userData", ["fetchUserData"]),
    // get status of international order
    async getStatusOrder() {
      if (this.orderCode != "") {
        this.isSearch = true;
        this.loadingSearch = true;
        await this.internationalSearch(this.orderCode);
        this.loadingSearch = false;
        this.isSearch = false;
        if (this.success_api_samsa_order) {
          this.haveOrder = true;
          this.successSearch = 1;
          this.errorSearchMessage = "";
        } else {
          this.successSearch = 0;
          this.errorSearchMessage = this.error_samsa_order;
        }
      } else {
        this.successSearch = 0;
        this.errorSearchMessage = " برجاء ادخال كود طلب اولاً";
      }
    },

    // close modal of adjust shipping costs || close modal of technical support numbers
    closePopup() {
      this.showModal = false;
      this.showNumbersModal = false;
    },

    // submit survey data
    async submitData() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loadingUpdateClientData = true;
          await this.submitSurvey({
            survey_id: this.surveyData.survey_id,
            survey_answers: this.surveyData.survey_type == 'checkbox' ? this.updateClientData : [this.updateClientData],
          });
          this.loadingUpdateClientData = false;
          if (this.success_submit_survey == 1) {
            this.notifySuccess("editToast");
            if (this.available_surveys) {
              this.loadingUpdateClientData = true;
              await this.getSurvey();
              this.loadingUpdateClientData = false;
            } else {
              localStorage.setItem("availableSurveys", 0);
              this.activeSurveysModal = false;
            }
          }
        }
      });
    },
    // get order change price requests
    async getOrderChangeRequestsPrice() {
      await this.fetchUserData();
      if (!this.checkAuthHasShowModalChangePrice) {
          this.showRequestsModal = false;
          return;
      }
      this.spin = true;
      let { data } = await Axios.get(process.env.VUE_APP_BASE_URL + 'order/get_order_change_requests');      
      if (data.order_change_requests.length > 0) {
        this.showRequestsModal = true;
        this.orderRequestsData = data.order_change_requests[0];
      } else {
            this.showRequestsModal = false;
      }
      this.spin = false
    },
    // change status order change price requests
    async changeStatusOrderChangeRequestsPrice(isAccepted) {
      this.spin = true;
      try {
        let { data } = await Axios.post(
          process.env.VUE_APP_BASE_URL + 'order/process_order_change_requests',
          {
            order_id: this.orderRequestsData.order_id,
            accept: isAccepted,
            partial_return: this.orderRequestsData.partial_return,
            socket_id: this.$socket.id
          }
        );
        if (data.success) {
          this.$vs.notify({
            title: 'نجاح',
            text: data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
          });
        } else {
          this.$vs.notify({
            title: 'خطأ',
            text: data.message || 'حدث خطأ أثناء تنفيذ العملية',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: 'خطأ في الاتصال',
          text: (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'تعذر الاتصال بالخادم، حاول مرة أخرى لاحقًا',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-octagon',
        });
      } finally {
        await this.getOrderChangeRequestsPrice();
        this.spin = false;
      }
    },
  },
  beforeDestroy() {
    // Clean up the socket listener when the component is destroyed
    this.$socket.off('close-modal-for-users-when-user-take-action');
  },
  async mounted() {
    this.$socket.emit("join", { name: 'close-modal-for-users-when-user-take-action' });
    this.$socket.on('close-modal-for-users-when-user-take-action', () => {
        this.showRequestsModal = false;
    });
    await this.getOrderChangeRequestsPrice();
  },
  async created() {
    if (localStorage.getItem("availableSurveys") > 0) {
      await this.getSurvey();
      this.activeSurveysModal = true;
    }
    let credentials = {
      page: "order/saved",
      pageNum: null,
      itemsPerPage: 6,
    };
    // fetch saved orders
    await this.fetchDataListItems(credentials);

    // fetch data about client works
    await this.fetchChart();
    this.sumChart =
      parseInt(this.chart.total_given) +
      parseInt(this.chart.total_return_OnSender) +
      parseInt(this.chart.total_return_OnReciever) +
      parseInt(this.chart.total_return_cancel);
    this.chartData = {
      labels: ["تم التسليم", "علي المرسل", "مدفوع", "إلغاء"],
      datasets: [
        {
          backgroundColor: ["#31006f", "#faae00", "#28C76F", "#d1002d"],
          data: [
            Math.ceil((this.chart.total_given / this.sumChart) * 100),
            Math.ceil((this.chart.total_return_OnSender / this.sumChart) * 100),
            Math.ceil(
              (this.chart.total_return_OnReciever / this.sumChart) * 100
            ),
            Math.ceil((this.chart.total_return_cancel / this.sumChart) * 100),
          ],
        },
      ],
    };
    this.loadHome = false;
    this.showModal = parseInt(localStorage.getItem("restored"));
    if (this.showModal) this.confirmRestored();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_home.scss";
</style>
<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
